/* eslint-disable no-use-before-define */

import React from "react";
import {
  ActivityIndicator,
  Button,
  Button as RNButton,
  Keyboard,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import Phone from "../utils/Phone";
import { connect } from "react-redux";
import {
  checkWifi,
  failWifi,
  resetConnectionStatus,
  setWifi,
} from "../redux/actions/connection";
import MenuButton from "../components/MenuButton";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import Icon from "react-native-vector-icons/FontAwesome";
import goTo from "../utils/goTo";
import WebHeading from "../components/WebHeading";

const questionCircle = (
  <Icon name="warning" size={100} color={errorColors.orange} />
);
const questionCircleSmall = (
  <Icon name="warning" size={24} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  connection: state.connection,
});

const mapDispatchToProps = (dispatch) => {
  return {
    connectionActions: bindActionCreators(
      { setWifi, checkWifi, failWifi, resetConnectionStatus },
      dispatch
    ),
  };
};

const WirelessLoading = ({ status, message, reset }) => {
  return status === "FAILED" ? (
    <View style={{ flex: 1, justifyContent: "center" }}>
      <View style={{ flex: 4, justifyContent: "center" }}>
        <Text style={{ textAlign: "center" }}>{questionCircle}</Text>
        <Text style={{ ...RepositStyles.paragraphText, marginVertical: 20 }}>
          We were unable to connect to the customers wifi hotspot. Please check
          the credentials or choose a different network.
        </Text>
      </View>
      <View style={{ flex: 1, justifyContent: "flex-start" }}>
        <Button
          title="Check Credentials"
          onPress={() => reset()}
          color={RepositColours.blue}
        />
      </View>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Text style={RepositStyles.paragraphText}>
          If the problem persists <Phone>call Reposit on</Phone>
        </Text>
      </View>
    </View>
  ) : (
    <View style={{ flex: 1, backgroundColor: "#3CA5D5" }}>
      <View style={{ flex: 4 }} />
      <View style={{ flex: 1 }}>
        <ActivityIndicator size="large" color="white" />
      </View>
      <View style={{ flex: 6 }}>
        <Text
          style={{
            ...RepositStyles.headerText,
            marginTop: 20,
            marginBottom: 10,
            color: "white",
          }}
        >
          {status === null
            ? null
            : status.charAt(0) + status.slice(1).toLowerCase()}
        </Text>
        <Text
          style={{
            ...RepositStyles.paragraphText,
            textAlign: "center",
            color: "white",
          }}
        >
          {message}
        </Text>
      </View>
    </View>
  );
};

class WirelessSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      showPassword: true,
      validationError: false,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  componentDidMount() {
    this.props.connectionActions.resetConnectionStatus();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.connection.status === "SUCCESS") {
      if (this.props.connection.status !== "SUCCESS") {
        goTo(this.props.navigation, "SoftwareInstallation");
      }
    }
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  setWifi = () => {
    if (Platform.OS !== "web") {
      Keyboard.dismiss();
    }
    if (this.state.password.length < 1) {
      this.setState({ validationError: true });
    } else {
      this.setState({ validationError: false });
      const conn = this.props.box.connection.wifi.selectedNetwork;
      this.props.connectionActions.setWifi(
        conn.essid,
        this.state.password,
        this.props.box.serialNumber
      );
      setTimeout(this.checkWifi, 15000);
    }
  };

  checkWifi = () => {
    if (
      this.props.connection.status !== "SUCCESS" &&
      this.props.connection.status !== "FAILED" &&
      this.props.connection.status !== null
    ) {
      this.props.connectionActions.checkWifi(this.props.box.serialNumber);
      setTimeout(this.checkWifi, 15000);
    }
  };

  // createTimeout = () => {
  //   this.timeoutFunc = setTimeout(asdasd, 300)
  //   if (this.timeoutFunc) {
  //     clearTimeout(this.timeoutFunc)
  //
  //
  //   }
  // }

  render() {
    const wifi = this.props.box.connection.wifi.selectedNetwork;
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        {this.props.connection.status === null ? (
          <View style={{ flex: 1 }}>
            <View style={{ flex: 1, justifyContent: "center" }}>
              <Text style={RepositStyles.headerText}>{wifi.essid}</Text>
            </View>
            <View style={{ flex: 3, alignItems: "center" }}>
              <View style={RepositStyles.textInputContainer}>
                <TextInput
                  onChangeText={(text) => this.setState({ password: text })}
                  value={this.state.password}
                  style={RepositStyles.textInput}
                  onSubmitEditing={() => this.setWifi()}
                  placeholder="Password"
                  secureTextEntry={!this.state.showPassword}
                  autoCapitalize="none"
                  autoCorrect={false}
                />
              </View>
              <Text
                onPress={() => this.toggleShowPassword()}
                style={{ color: RepositColours.blue, marginVertical: 10 }}
              >
                {this.state.showPassword ? "Hide Password" : "Show Password"}
              </Text>
              <View style={{ alignItems: "center", flex: 1, marginTop: 20 }}>
                <View style={{ flexDirection: "row", marginVertical: 10 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Strength
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {wifi.strength}dB
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginVertical: 10 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Quality
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {wifi.quality}%
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginVertical: 10 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Channel
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {wifi.channel}
                  </Text>
                </View>
              </View>
            </View>
            <View
              style={{
                flex: 1,
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              {this.state.validationError ? (
                <Text style={RepositStyles.paragraphText}>
                  {questionCircleSmall} Please enter wifi password
                </Text>
              ) : null}
            </View>
            <View
              style={{
                flex: 4,
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <RNButton
                title="Connect"
                onPress={() => this.setWifi()}
                color={RepositColours.blue}
              />
              <Text style={RepositStyles.nextSub}>and begin installation</Text>
            </View>
          </View>
        ) : (
          <View style={styles.wrapper}>
            <WirelessLoading
              status={this.props.connection.status}
              message={this.props.connection.message}
              reset={this.props.connectionActions.resetConnectionStatus}
            />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "white",
    flex: 1,
  },
  connectionBox: {
    flexDirection: "row",
    marginHorizontal: 40,
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "left",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    flex: 1,
    marginVertical: 10,
  },
  bodyText: {
    marginVertical: 10,
  },
  bodyTextContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  stepBox: {
    flexDirection: "row",
    marginBottom: 50,
    marginHorizontal: 50,
  },
  addressBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 10,
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 150,
  },
  textInput: {
    fontSize: 20,
    borderWidth: Platform.OS === "android" ? 0 : 1,
    borderRadius: Platform.OS === "android" ? 0 : 5,
    height: Platform.OS === "android" ? 50 : 30,
    textAlign: "center",
    marginBottom: 5,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WirelessSelection);



// WEBPACK FOOTER //
// ./src/containers/WirelessSelection.js